export const EMAIL_SENDER = '555 Correspondence <donotreply@555-platform.comcast.net>';

export default {
  EMAIL_SENDER,
};
